var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","rounded":"lg"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v(" "+_vm._s(_vm.$t('planning.totalRejections', { qty: _vm.totalRejections }))+" ")]),_c('v-card-text',[(_vm.options)?_c('highcharts',{attrs:{"options":_vm.options}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }